import React, { useState } from "react";

import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaYoutube,
  FaInstagram,
  FaGraduationCap,
  FaArrowRight,
  FaPaperPlane,
  FaChevronRight,
  FaClock,
  FaTools,
  FaWrench,
  FaBriefcase,
  FaHardHat,
  FaLaptopCode,
  FaCheckCircle,
} from "react-icons/fa";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const [email, setEmail] = useState("");
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();

    if (!email.trim()) return;

    setSubscribed(true);
    setEmail("");

    setTimeout(() => {
      setSubscribed(false);
    }, 3500);
  };

  return (
    <footer className="trade-footer">
      <style>{`
        .trade-footer {
          --trade-green: #0b6b3a;
          --trade-dark-green: #064d2a;
          --trade-light-green: #eaf7ef;
          --trade-yellow: #f4c430;
          --trade-gold: #dca900;
          --trade-black: #111111;
          --trade-dark: #171717;
          --trade-gray: #707070;
          --trade-light-gray: #f5f7f6;
          --trade-white: #ffffff;

          position: relative;
          width: 100%;
          overflow: hidden;
          background: var(--trade-black);
          color: var(--trade-white);
          font-family: "Poppins", "Segoe UI", Arial, sans-serif;
        }

        /* ==========================================
           TOP ACCENT
        ========================================== */

        .trade-footer-accent {
          display: grid;
          grid-template-columns: 1fr 2fr 1fr;
          width: 100%;
          height: 7px;
        }

        .trade-footer-accent span:nth-child(1) {
          background: var(--trade-green);
        }

        .trade-footer-accent span:nth-child(2) {
          background: var(--trade-yellow);
        }

        .trade-footer-accent span:nth-child(3) {
          background: var(--trade-green);
        }

        /* ==========================================
           MAIN FOOTER
        ========================================== */

        .trade-footer-main {
          position: relative;
          display: grid;
          grid-template-columns: 1.3fr 0.8fr 1.1fr;
          gap: 55px;
          max-width: 1450px;
          margin: 0 auto;
          padding: 75px 55px 65px;
        }

        .trade-footer-main::before {
          content: "";
          position: absolute;
          width: 360px;
          height: 360px;
          right: -180px;
          top: -170px;
          border: 1px solid rgba(244, 196, 48, 0.08);
          border-radius: 50%;
          pointer-events: none;
        }

        .trade-footer-main::after {
          content: "";
          position: absolute;
          width: 220px;
          height: 220px;
          right: -80px;
          top: -100px;
          border: 1px solid rgba(11, 107, 58, 0.15);
          border-radius: 50%;
          pointer-events: none;
        }

        /* ==========================================
           BRAND
        ========================================== */

        .trade-footer-brand-section {
          position: relative;
          z-index: 2;
        }

        .trade-footer-brand {
          display: flex;
          align-items: center;
          gap: 16px;
          margin-bottom: 24px;
        }

        .trade-footer-brand-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 58px;
          height: 58px;
          flex-shrink: 0;
          border-radius: 14px;
          background: var(--trade-yellow);
          color: var(--trade-black);
          font-size: 27px;
          box-shadow: 0 8px 25px rgba(244, 196, 48, 0.18);
          transition: 0.3s ease;
        }

        .trade-footer-brand:hover .trade-footer-brand-icon {
          transform: translateY(-4px) rotate(-3deg);
        }

        .trade-footer-brand-text h2 {
          margin: 0 0 5px;
          color: var(--trade-white);
          font-size: 22px;
          font-weight: 800;
          line-height: 1.2;
          letter-spacing: -0.4px;
        }

        .trade-footer-brand-text span {
          color: var(--trade-yellow);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 1.5px;
          text-transform: uppercase;
        }

        .trade-footer-description {
          max-width: 560px;
          margin: 0 0 27px;
          color: #c5c5c5;
          font-size: 14px;
          line-height: 1.9;
        }

        /* ==========================================
           TRADE VALUES
        ========================================== */

        .trade-footer-values {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          margin-bottom: 30px;
        }

        .trade-footer-value {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 9px 13px;
          border: 1px solid rgba(255, 255, 255, 0.09);
          border-radius: 7px;
          background: rgba(255, 255, 255, 0.035);
          color: #dedede;
          font-size: 12px;
          font-weight: 600;
          transition: 0.3s ease;
        }

        .trade-footer-value svg {
          color: var(--trade-yellow);
          font-size: 13px;
        }

        .trade-footer-value:hover {
          border-color: rgba(244, 196, 48, 0.35);
          background: rgba(244, 196, 48, 0.07);
          transform: translateY(-2px);
        }

        /* ==========================================
           SOCIAL
        ========================================== */

        .trade-footer-social-area {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 16px;
        }

        .trade-footer-social-area > span {
          color: #999;
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 1px;
        }

        .trade-footer-social-links {
          display: flex;
          gap: 8px;
        }

        .trade-footer-social-links a {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.04);
          color: #d8d8d8;
          font-size: 13px;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .trade-footer-social-links a:hover {
          border-color: var(--trade-yellow);
          background: var(--trade-yellow);
          color: var(--trade-black);
          transform: translateY(-4px);
        }

        /* ==========================================
           NAVIGATION
        ========================================== */

        .trade-footer-navigation-section {
          display: grid;
          grid-template-columns: 1fr;
          gap: 42px;
        }

        .trade-footer-column {
          position: relative;
          z-index: 2;
        }

        .trade-footer-title {
          display: flex;
          align-items: center;
          gap: 12px;
          margin-bottom: 22px;
        }

        .trade-footer-title-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 34px;
          height: 34px;
          border-radius: 8px;
          background: var(--trade-green);
          color: var(--trade-yellow);
          font-size: 13px;
        }

        .trade-footer-title h3 {
          margin: 0;
          color: var(--trade-white);
          font-size: 16px;
          font-weight: 750;
        }

        .trade-footer-column ul {
          margin: 0;
          padding: 0;
          list-style: none;
        }

        .trade-footer-column li {
          margin-bottom: 12px;
        }

        .trade-footer-column li a {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          color: #aaa;
          font-size: 13px;
          text-decoration: none;
          transition: all 0.3s ease;
        }

        .trade-footer-column li a svg {
          color: var(--trade-green);
          font-size: 9px;
          transition: 0.3s ease;
        }

        .trade-footer-column li a:hover {
          color: var(--trade-yellow);
          transform: translateX(5px);
        }

        .trade-footer-column li a:hover svg {
          color: var(--trade-yellow);
        }

        /* ==========================================
           CONTACT
        ========================================== */

        .trade-footer-contact-section {
          position: relative;
          z-index: 2;
        }

        .trade-footer-contact-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 13px;
        }

        .trade-footer-contact-card {
          display: flex;
          align-items: flex-start;
          gap: 13px;
          padding: 12px;
          border: 1px solid rgba(255, 255, 255, 0.07);
          border-radius: 9px;
          background: rgba(255, 255, 255, 0.025);
          transition: all 0.3s ease;
        }

        .trade-footer-contact-card:hover {
          border-color: rgba(244, 196, 48, 0.3);
          background: rgba(244, 196, 48, 0.035);
          transform: translateX(4px);
        }

        .trade-footer-contact-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          flex-shrink: 0;
          border-radius: 8px;
          background: rgba(11, 107, 58, 0.25);
          color: var(--trade-yellow);
          font-size: 13px;
        }

        .trade-footer-contact-card span {
          display: block;
          margin-bottom: 4px;
          color: #888;
          font-size: 10px;
          font-weight: 700;
          letter-spacing: 1px;
          text-transform: uppercase;
        }

        .trade-footer-contact-card p {
          margin: 0;
          color: #d1d1d1;
          font-size: 12px;
          line-height: 1.6;
          word-break: break-word;
        }

        /* ==========================================
           CONNECTION / NEWSLETTER
        ========================================== */

        .trade-footer-connect {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 35px;
          max-width: 1340px;
          margin: 0 auto;
          padding: 28px 35px;
          border-top: 1px solid rgba(255, 255, 255, 0.08);
          border-bottom: 1px solid rgba(255, 255, 255, 0.08);
        }

        .trade-footer-connect-content {
          display: flex;
          align-items: center;
          gap: 15px;
        }

        .trade-footer-connect-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 46px;
          height: 46px;
          flex-shrink: 0;
          border-radius: 11px;
          background: var(--trade-green);
          color: var(--trade-yellow);
          font-size: 17px;
        }

        .trade-footer-connect-content h4 {
          margin: 0 0 4px;
          color: var(--trade-white);
          font-size: 15px;
        }

        .trade-footer-connect-content p {
          margin: 0;
          color: #888;
          font-size: 12px;
        }

        .trade-footer-newsletter {
          display: flex;
          width: min(100%, 500px);
          border: 1px solid rgba(255, 255, 255, 0.12);
          border-radius: 8px;
          overflow: hidden;
          background: #0e0e0e;
        }

        .trade-footer-newsletter input {
          min-width: 0;
          flex: 1;
          border: 0;
          outline: none;
          padding: 14px 16px;
          background: transparent;
          color: white;
          font-family: inherit;
          font-size: 12px;
        }

        .trade-footer-newsletter input::placeholder {
          color: #666;
        }

        .trade-footer-newsletter button {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 9px;
          min-width: 125px;
          border: 0;
          background: var(--trade-yellow);
          color: var(--trade-black);
          cursor: pointer;
          font-family: inherit;
          font-size: 12px;
          font-weight: 800;
          transition: all 0.3s ease;
        }

        .trade-footer-newsletter button:hover {
          background: #ffd84d;
        }

        .trade-footer-newsletter button svg {
          font-size: 11px;
        }

        .trade-footer-success {
          padding: 13px 16px;
          color: var(--trade-yellow);
          font-size: 12px;
          font-weight: 700;
        }

        /* ==========================================
           MOTTO
        ========================================== */

        .trade-footer-motto {
          display: flex;
          align-items: center;
          gap: 20px;
          max-width: 900px;
          margin: 0 auto;
          padding: 38px 25px;
        }

        .trade-footer-motto span {
          height: 1px;
          flex: 1;
          background: linear-gradient(
            to right,
            transparent,
            rgba(244, 196, 48, 0.5)
          );
        }

        .trade-footer-motto span:last-child {
          background: linear-gradient(
            to left,
            transparent,
            rgba(244, 196, 48, 0.5)
          );
        }

        .trade-footer-motto p {
          margin: 0;
          color: var(--trade-yellow);
          font-size: 12px;
          font-weight: 700;
          text-align: center;
          letter-spacing: 1.4px;
          text-transform: uppercase;
          white-space: nowrap;
        }

        /* ==========================================
           BOTTOM
        ========================================== */

        .trade-footer-bottom {
          background: #090909;
          border-top: 1px solid rgba(255, 255, 255, 0.06);
        }

        .trade-footer-bottom-inner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 25px;
          max-width: 1450px;
          margin: 0 auto;
          padding: 22px 55px;
        }

        .trade-footer-bottom-inner > p {
          margin: 0;
          color: #707070;
          font-size: 11px;
          line-height: 1.6;
        }

        .trade-footer-bottom-links {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .trade-footer-bottom-links a {
          color: #777;
          font-size: 11px;
          text-decoration: none;
          transition: 0.3s ease;
        }

        .trade-footer-bottom-links a:hover {
          color: var(--trade-yellow);
        }

        .trade-footer-bottom-links span {
          color: #333;
          font-size: 11px;
        }

        /* ==========================================
           TRADE BADGE
        ========================================== */

        .trade-footer-training-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          margin-top: 20px;
          padding: 9px 13px;
          border-left: 3px solid var(--trade-yellow);
          background: rgba(11, 107, 58, 0.18);
          color: #ddd;
          font-size: 11px;
          font-weight: 600;
        }

        .trade-footer-training-badge svg {
          color: var(--trade-yellow);
        }

        /* ==========================================
           RESPONSIVE
        ========================================== */

        @media (max-width: 1100px) {
          .trade-footer-main {
            grid-template-columns: 1fr 1fr;
            gap: 45px;
          }

          .trade-footer-brand-section {
            grid-column: span 2;
          }

          .trade-footer-description {
            max-width: 800px;
          }

          .trade-footer-navigation-section {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (max-width: 800px) {
          .trade-footer-main {
            grid-template-columns: 1fr;
            padding: 55px 28px 45px;
            gap: 42px;
          }

          .trade-footer-brand-section {
            grid-column: auto;
          }

          .trade-footer-navigation-section {
            grid-template-columns: 1fr 1fr;
          }

          .trade-footer-connect {
            flex-direction: column;
            align-items: stretch;
            padding: 28px;
          }

          .trade-footer-newsletter {
            width: 100%;
          }

          .trade-footer-bottom-inner {
            flex-direction: column;
            align-items: flex-start;
            padding: 22px 28px;
          }
        }

        @media (max-width: 600px) {
          .trade-footer-brand {
            align-items: flex-start;
          }

          .trade-footer-brand-icon {
            width: 50px;
            height: 50px;
            font-size: 23px;
          }

          .trade-footer-brand-text h2 {
            font-size: 18px;
          }

          .trade-footer-brand-text span {
            font-size: 9px;
            letter-spacing: 1px;
          }

          .trade-footer-navigation-section {
            grid-template-columns: 1fr;
            gap: 35px;
          }

          .trade-footer-values {
            display: grid;
            grid-template-columns: 1fr 1fr;
          }

          .trade-footer-value {
            width: 100%;
            box-sizing: border-box;
          }

          .trade-footer-social-area {
            align-items: flex-start;
            flex-direction: column;
          }

          .trade-footer-connect {
            padding: 25px 20px;
          }

          .trade-footer-newsletter {
            display: flex;
            flex-direction: column;
            border: 0;
            overflow: visible;
            background: transparent;
            gap: 8px;
          }

          .trade-footer-newsletter input {
            width: 100%;
            box-sizing: border-box;
            border: 1px solid rgba(255, 255, 255, 0.12);
            border-radius: 8px;
            background: #0e0e0e;
            padding: 14px;
          }

          .trade-footer-newsletter button {
            min-height: 45px;
            width: 100%;
            border-radius: 8px;
          }

          .trade-footer-motto {
            padding: 32px 20px;
          }

          .trade-footer-motto span {
            display: none;
          }

          .trade-footer-motto p {
            width: 100%;
            white-space: normal;
            line-height: 1.6;
          }

          .trade-footer-bottom-inner {
            padding: 22px 20px;
          }

          .trade-footer-bottom-links {
            gap: 8px;
          }
        }

        @media (max-width: 400px) {
          .trade-footer-main {
            padding-left: 18px;
            padding-right: 18px;
          }

          .trade-footer-values {
            grid-template-columns: 1fr;
          }

          .trade-footer-brand-text h2 {
            font-size: 16px;
          }

          .trade-footer-description {
            font-size: 13px;
          }

          .trade-footer-bottom-links {
            flex-direction: column;
            align-items: flex-start;
          }

          .trade-footer-bottom-links span {
            display: none;
          }
        }
      `}</style>

      {/* ==========================================
          TOP ACCENT
      ========================================== */}

      <div className="trade-footer-accent">
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* ==========================================
          MAIN FOOTER
      ========================================== */}

      <div className="trade-footer-main">

        {/* BRAND SECTION */}

        <div className="trade-footer-brand-section">

          <div className="trade-footer-brand">

            <div className="trade-footer-brand-icon">
              <FaTools />
            </div>

            <div className="trade-footer-brand-text">

              <h2>
                Ignite S 
                <br />
                Skill Center
              </h2>

              <span>
                Skills • Training • Opportunity
              </span>

            </div>

          </div>

          <p className="trade-footer-description">
            Empowering young people and adults with practical technical
            skills, vocational training, entrepreneurship knowledge, and
            workplace readiness for meaningful careers and productive
            livelihoods.
          </p>

          <div className="trade-footer-values">

            <div className="trade-footer-value">
              <FaTools />
              <span>Practical Skills</span>
            </div>

            <div className="trade-footer-value">
              <FaHardHat />
              <span>Hands-On Training</span>
            </div>

            <div className="trade-footer-value">
              <FaBriefcase />
              <span>Career Ready</span>
            </div>

            <div className="trade-footer-value">
              <FaLaptopCode />
              <span>Modern Technology</span>
            </div>

          </div>

          <div className="trade-footer-training-badge">
            <FaCheckCircle />
            Training for Employment & Entrepreneurship
          </div>

          <div className="trade-footer-social-area">

            <span>
              Connect With Us
            </span>

            <div className="trade-footer-social-links">

              <a
                href="#"
                aria-label="Facebook"
              >
                <FaFacebookF />
              </a>

              <a
                href="#"
                aria-label="YouTube"
              >
                <FaYoutube />
              </a>

              <a
                href="#"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>

            </div>

          </div>

        </div>

        {/* NAVIGATION */}

        <div className="trade-footer-navigation-section">

          <div className="trade-footer-column">

            <div className="trade-footer-title">

              <span className="trade-footer-title-icon">
                <FaArrowRight />
              </span>

              <h3>
                Quick Links
              </h3>

            </div>

            <ul>

              <li>
                <a href="#home">
                  <FaChevronRight />
                  <span>Home</span>
                </a>
              </li>

              <li>
                <a href="#about">
                  <FaChevronRight />
                  <span>About Us</span>
                </a>
              </li>

              <li>
                <a href="#courses">
                  <FaChevronRight />
                  <span>Our Courses</span>
                </a>
              </li>

              <li>
                <a href="#admissions">
                  <FaChevronRight />
                  <span>Admissions</span>
                </a>
              </li>

              <li>
                <a href="#contact">
                  <FaChevronRight />
                  <span>Contact Us</span>
                </a>
              </li>

            </ul>

          </div>

          <div className="trade-footer-column">

            <div className="trade-footer-title">

              <span className="trade-footer-title-icon">
                <FaWrench />
              </span>

              <h3>
                Training
              </h3>

            </div>

            <ul>

              <li>
                <a href="#courses">
                  <FaChevronRight />
                  <span>Computer Science</span>
                </a>
              </li>

              <li>
                <a href="#electrical">
                  <FaChevronRight />
                  <span>Tailoring</span>
                </a>
              </li>

              <li>
                <a href="#automotive">
                  <FaChevronRight />
                  <span>Cosmetology</span>
                </a>
              </li>

              <li>
                <a href="#fashion">
                  <FaChevronRight />
                  <span>Decoration</span>
                </a>
              </li>

              <li>
                <a href="#ict">
                  <FaChevronRight />
                  <span>Pastry/Catering</span>
                </a>
              </li>

              <li>
                <a href="#woodwork">
                  <FaChevronRight />
                  <span>Tie & Dye</span>
                </a>
              </li>

            <li>
                <a href="#woodwork">
                  <FaChevronRight />
                  <span>Electricity</span>
                </a>
              </li>

                            <li>
                <a href="#woodwork">
                  <FaChevronRight />
                  <span>Plumbing</span>
                </a>
              </li>

            </ul>

          </div>

        </div>

        {/* CONTACT */}

        <div className="trade-footer-contact-section">

          <div className="trade-footer-title">

            <span className="trade-footer-title-icon">
              <FaMapMarkerAlt />
            </span>

            <h3>
              Contact Us
            </h3>

          </div>

          <div className="trade-footer-contact-grid">

            <div className="trade-footer-contact-card">

              <div className="trade-footer-contact-icon">
                <FaMapMarkerAlt />
              </div>

              <div>

                <span>
                  Visit Us
                </span>

                <p>
                  Johnsonville Monrovia, Liberia
                </p>

              </div>

            </div>

            <div className="trade-footer-contact-card">

              <div className="trade-footer-contact-icon">
                <FaPhoneAlt />
              </div>

              <div>

                <span>
                  Call Us
                </span>

                <p>
                  +1 520 265 7981
                </p>

              </div>

            </div>

            <div className="trade-footer-contact-card">

              <div className="trade-footer-contact-icon">
                <FaEnvelope />
              </div>

              <div>

                <span>
                  Email Us
                </span>

                <p>
                  sumawolo65@gmail.com
                </p>

              </div>

            </div>

            <div className="trade-footer-contact-card">

              <div className="trade-footer-contact-icon">
                <FaClock />
              </div>

              <div>

                <span>
                  Office Hours
                </span>

                <p>
                  Mon - Fri: 8:00 AM - 4:00 PM
                </p>

              </div>

            </div>

          </div>

        </div>

      </div>

      {/* ==========================================
          NEWSLETTER
      ========================================== */}

      <div className="trade-footer-connect">

        <div className="trade-footer-connect-content">

          <div className="trade-footer-connect-icon">
            <FaEnvelope />
          </div>

          <div>

            <h4>
              Stay Connected
            </h4>

            <p>
              Receive training news, admissions information, and school updates.
            </p>

          </div>

        </div>

        {subscribed ? (

          <div className="trade-footer-success">
            ✓ Thank you! You are now connected with us.
          </div>

        ) : (

          <form
            className="trade-footer-newsletter"
            onSubmit={handleSubscribe}
          >

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              aria-label="Email address"
              required
            />

            <button
              type="submit"
              aria-label="Subscribe to newsletter"
            >
              Subscribe
              <FaPaperPlane />
            </button>

          </form>

        )}

      </div>

      {/* ==========================================
          MOTTO
      ========================================== */}

      <div className="trade-footer-motto">

        <span></span>

        <p>
          Learn a Skill. Build a Career. Create Your Future.
        </p>

        <span></span>

      </div>

      {/* ==========================================
          COPYRIGHT
      ========================================== */}

      <div className="trade-footer-bottom">

        <div className="trade-footer-bottom-inner">

          <p>
            © {currentYear} Ignite S Skill Center.
            All Rights Reserved.
          </p>

          <div className="trade-footer-bottom-links">

            <a href="#privacy">
              Privacy Policy
            </a>

            <span>|</span>

            <a href="#terms">
              Terms & Conditions
            </a>

            <span>|</span>

            <a href="#support">
              System Support
            </a>

          </div>

        </div>

      </div>

    </footer>
  );
}